import React, { useState } from 'react';
import { EmptyPage } from '../../pages/EmptyPage';
import { useDispatch, useSelector } from 'react-redux';
import { getAvailableOrderUsers } from '../../helpers';
import { assignOrder } from '../../redux/orderSlice';
import { Button } from '../Button';
import { PopupList } from '../PopupList';

export const SelectWorkerPopup = ({ order, closeFn }) => {
    const dispatch = useDispatch();

    const botTelegramId = useSelector((state) => state.settings.botTelegramId);
    const orderUserIds = useSelector((state) => state.settings.orderUsers);
    const orderUsers = useSelector((state) => state.users.list).filter((u) =>
        orderUserIds.some((u2) => u2 === u._id),
    );
    const availableOrderUsers = getAvailableOrderUsers(
        orderUsers,
        order.city,
        order.profileType,
        botTelegramId,
    );

    const [selectedWorker, setWorker] = useState(null);

    const assignOrderHandler = () => {
        if (selectedWorker) {
            dispatch(assignOrder({ orderId: order._id, userId: selectedWorker }));
            closeFn();
        }
    };

    const popupTitle = `Список мастеров [${order.profileType.name}, ${order.city.name}]`;
    const WorkerItem = ({ data }) => {
        const reversedFullname = `${data.fullname.split(' ')[1]} ${data.fullname.split(' ')[0]}`
        return (
            <div
                className={`worker-list__item worker-item ${
                    selectedWorker === data._id ? 'selected dark-theme-bg1' : ''
                }`}
                onClick={() => setWorker(data._id)}>
                <div className="worker-item__fullname">{reversedFullname}</div>
                <div className="worker-item__status">
                    {data.isBusy || !data.activated ? (
                        <span className="worker-busy">{data.activated ? 'Занят' : 'Не активирован'}</span>
                    ) : (
                        <span className="worker-free">Свободен</span>
                    )}
                </div>
            </div>
        );
    };

    const sortedWorkers = [...availableOrderUsers].sort((a, b) => a.fullname.split(' ')[1].localeCompare(b.fullname.split(' ')[1]));

    const workerElements = availableOrderUsers.length ?
        sortedWorkers.map((worker) => (
            <WorkerItem key={worker._id} data={worker} />
        )) : [<EmptyPage message="Нет подходящих мастеров" key={0} />];

    const createSearchFn = (_, val) => (el) => availableOrderUsers.length ? el.props.data.fullname.toLowerCase().includes(val.toLowerCase()) : false

    return (
        <PopupList
            title={popupTitle}
            closeFn={closeFn}
            button={
                <Button text={`Отправить заявку id${order.id}`} onClick={assignOrderHandler} />
            }
            listClassName='worker-list'
            children={workerElements}
            search={{
                createSearch: createSearchFn
            }}>
        </PopupList>
    );
};
